/* eslint-disable */

import { makeStyles } from "@material-ui/core";
import { Delete, Info } from "@material-ui/icons";
import Edit from "@material-ui/icons/Edit";
import { DialogContent } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "components/CustomButtons/Button.js";
import TablePaginate from "components/TablePaginate/TablePaginate";
import { networkConfig } from "const";
import { ethers } from "ethers";
import useEthers from "hooks/useEthers";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { bridgeService } from "services/bridgeService";
import BridgeTokenABI from "../../contracts/BridgeToken.json";
import { bridgeContract, optionChain } from "./BridgeCreate";
import numeral from "numeral";
import { Controller, useForm } from "react-hook-form";
import CustomInput from "components/CustomInput/CustomInput";
import Select from "components/Select/Select";

const chainsMainnet = {
  56: "BNB Smart Chain Mainnet",
  8453: "Base",
  137: "Polygon",
  25: "Cronos",
  81457: "Blast",
};

const chainsTestnet = {
  97: "BSC Testnet",
  84532: "Base Testnet",
  80002: "Amoy",
};

export const chains = process.env.NODE_ENV === "development" ? chainsTestnet : chainsMainnet;

const defaultValues = {
  name: "",
  chainId: 25,
  targetChainId: "",
};

export default function BridgeIndex() {
  const { register, handleSubmit, control } = useForm({ defaultValues });
  const [size] = React.useState(10);

  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        Header: "Current ChainId",
        accessor: "currentChainId",
        Cell: ({ cell }) => {
          return <p>{chains[cell.row.original.currentChainId]}</p>;
        },
      },
      {
        Header: "Token Address",
        accessor: "token",
      },
      {
        Header: "Token Name",
        accessor: "tokenName",
      },
      {
        Header: "Target Token Address",
        accessor: "targetToken",
      },
      {
        Header: "Target Token Name",
        accessor: "targetTokenName",
      },

      {
        Header: "Target ChainId",
        accessor: "targetChainId",
        Cell: ({ cell }) => {
          return <p>{chains[cell.row.original.targetChainId]}</p>;
        },
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <>
              <Action cell={cell} setItems={setItems}></Action>
            </>
          );
        },
      },
    ],
    [],
  );

  async function fetchBridges() {
    const payload = {
      page,
      size,
      sortBy: "order",
      sortType: "asc",
    };
    try {
      const { data } = await bridgeService.list(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
    } catch (e) {
      console.log(e);
    }
  }

  async function onSubmit(form) {
    try {
      console.log(form);
      console.log(bridgeContract[+form.chainId]);

      await window.ethereum.request({ method: "eth_requestAccounts" });
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(bridgeContract[+form.chainId], BridgeTokenABI, signer);

      const tx = await contract.addChain(form.targetChainId, form.name);
      await tx.wait();
      toast.success("Add chain success");

      setIsLoading(true);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  React.useEffect(() => {
    fetchBridges();
  }, [page]);

  return (
    <div>
      {confirm}
      <Link to="/admin/approve-token">
        <Button color="info">Approve Token</Button>
      </Link>

      {/* <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
          <div style={{ width: 200 }}>
            <Controller
              control={control}
              name="chainId"
              render={({ field: { value, onChange } }) => (
                <Select
                  name="chainId"
                  label="Chain"
                  onChange={onChange}
                  value={value ?? 25}
                  options={optionChain}
                />
              )}
            />
          </div>

          <div style={{ width: 400 }}>
            <CustomInput
              labelText="NAME"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                ...register("name"),
              }}
            />
          </div>

          <div style={{ width: 200 }}>
            <CustomInput
              labelText="Target ChainId"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                type: "text",
                ...register("targetChainId"),
              }}
            />
          </div>
          <div style={{ paddingBottom: 10 }}>
            <Button color="rose" type="submit">
              {isLoading ? "Loading..." : "Add"}
            </Button>
          </div>
        </div>
      </form> */}

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

function Action({ cell, setItems }) {
  const [openDialogDel, setOpenDialogDel] = React.useState(false);
  const [openDialogInfo, setOpenDialogInfo] = React.useState(false);
  const { connectWallet } = useEthers();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingWithdraw, setIsLoadingWithdraw] = useState(false);
  const [pools, setPools] = useState({
    poolCurrent: 0,
    poolTarget: 0,
  });

  const handleActionPool = async () => {
    try {
      setOpenDialogInfo(true);
      setIsLoading(true);
      const { targetChainId, currentChainId, targetToken, token } = cell.row.original;

      if (!targetToken || !token) return;

      const getProvider = (chainId) => {
        const rpcUrl = networkConfig[chainId].rpcUrls[0];
        return new ethers.providers.JsonRpcProvider(rpcUrl);
      };

      const getBridgeContract = (chainId, provider) => {
        return new ethers.Contract(bridgeContract[chainId], BridgeTokenABI, provider);
      };

      const provider1 = getProvider(targetChainId);
      const provider2 = getProvider(currentChainId);

      const bridgeTokenContract1 = getBridgeContract(targetChainId, provider1);
      const bridgeTokenContract2 = getBridgeContract(currentChainId, provider2);

      const [poolTarget, poolCurrent] = await Promise.all([
        bridgeTokenContract1.getLiquidity(targetToken),
        bridgeTokenContract2.getLiquidity(token),
      ]);

      setPools((cur) => ({
        ...cur,
        poolCurrent: ethers.utils.formatEther(poolCurrent.toString()),
        poolTarget: ethers.utils.formatEther(poolTarget.toString()),
      }));
    } catch (error) {
      console.error("Failed to fetch pool data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (payload) => {
    try {
      if (!payload?._id) return;
      setIsLoading(true);
      const { signer, chainId, provider } = await connectWallet();
      if (payload.currentChainId !== chainId) {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: `0x${parseInt(payload.currentChainId, 10).toString(16)}` }],
        });
      }

      const bridgeTokenContract = new ethers.Contract(
        bridgeContract[payload.currentChainId],
        BridgeTokenABI,
        signer,
      );
      const tx = await bridgeTokenContract.disallowToken(payload.token);
      await tx.wait();

      const receipt = await provider.getTransactionReceipt(tx.hash);

      if (receipt) {
        if (receipt.status === 1) {
          await bridgeService.remove(payload?._id);
          setItems((prev) => prev.filter((bridge) => bridge._id !== payload?._id));
          toast.success("Delete success!");
          console.log("Transaction succeeded");
        }
      }
    } catch (e) {
      toast.error(e?.response?.data?.message[0]);
      toast.error(e?.message);
      console.log(e);
    } finally {
      setIsLoading(false);
      setOpenDialogDel(false);
    }
  };

  const handleWithdrawLiquidity = async (chainId, tokenAddress) => {
    try {
      setIsLoadingWithdraw(true);

      if (!chainId || !tokenAddress) {
        console.error("Missing required information for withdrawal.");
        return;
      }

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const network = await provider.getNetwork();

      if (network.chainId !== chainId) {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: `0x${chainId.toString(16)}` }],
        });
      }

      const bridgeTokenContract = new ethers.Contract(
        bridgeContract[chainId],
        BridgeTokenABI,
        signer,
      );

      const tx = await bridgeTokenContract.withdrawLiquidity(tokenAddress);
      console.log(`Transaction sent: ${tx.hash}`);

      const receipt = await tx.wait();
      console.log("Transaction confirmed:", receipt);

      toast.success("Withdrawal successful!");
    } catch (error) {
      console.error("Failed to withdraw liquidity:", error);
      toast.error("Withdrawal failed. Please try again.");
    } finally {
      setIsLoadingWithdraw(false);
    }
  };

  return (
    <div className="actions-right">
      <Button
        justIcon
        round
        simple
        color="warning"
        className="edit"
        onClick={() => setOpenDialogDel(true)}
      >
        <Delete />
      </Button>

      <Dialog
        open={openDialogDel}
        onClose={() => setOpenDialogDel(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Remove Token"}</DialogTitle>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button onClick={() => setOpenDialogDel(false)} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(cell.row.original);
            }}
            color="warning"
          >
            {isLoading ? "Loading..." : "Agree"}
          </Button>
        </DialogActions>
      </Dialog>

      <Link to={"/admin/approve-token/" + cell.row.original._id}>
        <Button justIcon round simple color="primary" className="edit">
          <Edit />
        </Button>
      </Link>

      <Button justIcon round simple color="success" className="edit" onClick={handleActionPool}>
        <Info />
      </Button>

      <Dialog open={openDialogInfo} onClose={() => setOpenDialogInfo(false)}>
        <DialogContent>
          <p>[{networkConfig[cell.row.original.currentChainId].chainName}]</p>
          <p>
            POOL ADDRESS: <strong>{cell.row.original.token}</strong>
          </p>
          <p>
            POOL: {!isLoading ? numeral(+pools.poolCurrent).format("0,0.[00000]") : "Loading..."}
          </p>
          <Button
            onClick={() =>
              isLoadingWithdraw
                ? {}
                : handleWithdrawLiquidity(cell.row.original.currentChainId, cell.row.original.token)
            }
            color="info"
          >
            {isLoadingWithdraw ? "Loading..." : "Withdraw"}
          </Button>
          <hr />
          <p>[{networkConfig[cell.row.original.targetChainId].chainName}]</p>
          <p>
            POOL ADDRESS: <strong>{cell.row.original.targetToken}</strong>
          </p>
          <p>
            POOL: {!isLoading ? numeral(+pools.poolTarget).format("0,0.[00000]") : "Loading..."}
          </p>
          <Button
            onClick={() =>
              isLoadingWithdraw
                ? {}
                : handleWithdrawLiquidity(
                    cell.row.original.targetChainId,
                    cell.row.original.targetToken,
                  )
            }
            color="info"
          >
            {isLoadingWithdraw ? "Loading..." : "Withdraw"}
          </Button>
        </DialogContent>

        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button onClick={() => setOpenDialogInfo(false)} color="default">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  onCloseModal: PropTypes.any,
};
